import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Page} from '../../utils/page';
import {PricingItemVersion} from '../../models/quote/pricing-item-version';
import {from, map, Observable} from 'rxjs';
import {ProductManagerV2Service} from './product-manager-v2.service';
import {ProductSearchRequestV2} from '../../models/quote/product-search-request-v2';
import {ProductMapperV2Service} from './product-mapper-v2.service';
import {ProductWithChildrenV2} from '../../models/productv2/productv2-children.model';
import {PriceList} from '../../models/productv2/pricelist.model';
import {Store} from '@ngrx/store';
import {StandaloneState} from '../../store/standalone';
import {selectStandaloneState} from '../../store';
import {filter, take} from 'rxjs/operators';
import {SqliteProductV2Repository} from '../../sqllite/repositories/products/sqlite-product-v2.repository';
import {SqlitePriceListV2Repository} from '../../sqllite/repositories/products/sqlite-price-list-v2.repository';

@Injectable()
export class StandaloneProductManagerV2Service extends ProductManagerV2Service {

    constructor(private readonly store: Store<StandaloneState>, private readonly http: HttpClient, protected productMapper: ProductMapperV2Service,
                private readonly sqliteProductV2Repository: SqliteProductV2Repository, private readonly sqlitePriceListV2Repository: SqlitePriceListV2Repository
    ) {
        super(productMapper);
    }

    searchArticles(productSearchRequest: ProductSearchRequestV2, pageable: Map<string, string>): Observable<Page<ProductWithChildrenV2>> {
        return this.processSearchArticle(productSearchRequest, pageable, false);
    }

    getActivePricingItemVersion(countryIsoCode: string): Observable<PricingItemVersion> {
        return this.store.select(selectStandaloneState).pipe(
            map(state => state.currentStandardVersion),
            filter((id): id is string => !!id),
            map(id => id.replace(/"/g, '')),
            map(id => Object.assign(new PricingItemVersion(), { id })),
            take(1)
        );
    }

    getClassification(id: number): Observable<PriceList> {
        return from(this.sqlitePriceListV2Repository.getProductsPriceListForActiveVersion(id)).pipe(
            map(classification => this.productMapper.hydratePriceList(classification))
        );
    }

    searchArticlesByFilteredElisCodes(productSearchRequestV2: ProductSearchRequestV2): Observable<{ content: ProductWithChildrenV2[] }> {
        if (!productSearchRequestV2.elisCodeList?.length) {
            return new Observable(observer => {
                observer.next({content: []});
                observer.complete();
            });
        }
        let size = productSearchRequestV2.elisCodeList?.length;
        let pageable = new Map()
            .set('page', 0)
            .set('size', size);

        return this.searchArticles(productSearchRequestV2, pageable).pipe(
            map(page => ({content: page.content}))
        );
    }

    searchAtomicArticles(productSearchRequest: ProductSearchRequestV2, pageable: Map<string, string>): Observable<Page<ProductWithChildrenV2>> {
        return this.processSearchArticle(productSearchRequest, pageable, true);
    }

    private processSearchArticle(productSearchRequest: ProductSearchRequestV2, pageable: Map<string, string>, atomicOnly: boolean) {
        return from(this.sqliteProductV2Repository.searchArticles(productSearchRequest, pageable, atomicOnly));
    }
}
